import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, PRESET_ROLE_LABELS } from "@/i18n/translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("alignee_lang") || "tr");

  useEffect(() => {
    localStorage.setItem("alignee_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    const parts = key.split(".");
    const resolve = (dict) => parts.reduce((acc, p) => (acc == null ? acc : acc[p]), dict);
    const val = resolve(translations[lang]);
    if (val != null) return val;
    const fallback = resolve(translations.tr);
    return fallback != null ? fallback : key;
  }, [lang]);

  const roleLabel = useCallback((role) => {
    if (!role) return role;
    if (lang === "en") return PRESET_ROLE_LABELS.en[role] || role;
    return role;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, roleLabel }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
